import { useModal } from 'modals';
import type { ReactNode } from 'react';

interface APIAccessLinkProps {
  children: ReactNode;
}

export default function APIAccessLink({ children }: APIAccessLinkProps) {
  const { open } = useModal();

  return (
    <button
      type="button"
      onClick={() =>
        open('ENTERPRISE_CONTACT', { reason: 'product_technical_support' })
      }
      className="hover:text-blue-60 inline cursor-pointer border-0 bg-transparent p-0 align-baseline text-blue-50 underline underline-offset-2 transition-colors"
    >
      {children}
    </button>
  );
}
